export const RENEWAL_COOL_OFF = 'RENEWAL_COOL_OFF';

export const READY_FOR_RENEWAL = 'READY_FOR_RENEWAL';
